export default __webpack_public_path__ + "static/media/im-img.a09ef412.webp";